import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems.js";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems.js";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import MaskInput from "react-maskinput";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle, MaskedInput, MaskedInputLabel } from "../baseItems";
import Base from "./base";

export default class Crypto extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			isWalletMaskVisible: false,
			account: "",
			accountValue: "",
			stake: "",
			selectedCurrency: "",
			cryptocurrency: "",
			canForward: false,
		};
		this.walletInputRef = React.createRef();
	}

	componentDidMount() {
		this.checkRequiredFields();
		super.componentDidMount();
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.account !== this.state.account ||
			prevState.accountValue !== this.state.accountValue ||
			prevState.stake !== this.state.stake ||
			prevState.selectedCurrency !== this.state.selectedCurrency ||
			prevState.cryptocurrency !== this.state.cryptocurrency
		) {
			this.checkRequiredFields();
		}
	}

	handleFocus = (field) => {
		this.setState({ [field]: true });
	};

	handleBlur = (field, value) => {
		const cleanedValue = value.replace(/_/g, "").trim();
		const isEmptyOrMasked = cleanedValue === "";
		this.setState(
			{
				[field]: false,
				[`${field.replace("is", "").toLowerCase()}Value`]: isEmptyOrMasked
					? ""
					: cleanedValue,
			},
			this.checkRequiredFields
		);
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		this.setState({ [field]: value, [`${field}Value`]: value }, this.checkRequiredFields);
	};

	checkRequiredFields = () => {
		const { stake, accountValue, cryptocurrency, selectedCurrency } = this.state;

		if (stake && accountValue && cryptocurrency && selectedCurrency) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	onSelectCryptocurrency(e) {
		this.setState(
			{
				cryptocurrency: e.label,
			},
			() => {
				this.checkRequiredFields();
			}
		);
	}

	getStep1(translate) {
		const {
			stake,
			selectedCurrency,
			cryptocurrency,
			isWalletMaskVisible,
			account,
			accountValue,
		} = this.state;

		const options = [
			{ value: 0, label: translate("PLEASE_SELECT") },
			{ value: 1, label: "BTC" },
			{ value: 2, label: "ETH" },
			{ value: 3, label: "LTC" },
			{ value: 4, label: "XRP" },
			{ value: 5, label: "BCH" },
		];

		let selectedCrypto = cryptocurrency
			? options.find((o) => o.label === cryptocurrency).value
			: 0;

		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<Fragment>
						<FormItem onRegister={() => this.registerField({ name: "cryptocurrency" })}>
							<Box>
								<BoxTitle>{translate("Select_Crypto_Currency")}</BoxTitle>
								<PaymentSelect
									options={options}
									value={selectedCrypto}
									handleSelect={this.onSelectCryptocurrency.bind(this)}
								/>
							</Box>
						</FormItem>
						<FormItem onRegister={() => this.registerField({ name: "account" })}>
							<Box>
								<MaskedInput>
									<MaskInput
										ref={this.walletInputRef}
										onFocus={() => this.handleFocus("isWalletMaskVisible")}
										onBlur={(e) =>
											this.handleBlur("isWalletMaskVisible", e.target.value)
										}
										maskChar={isWalletMaskVisible ? "_" : ""}
										mask="******************************************"
										size={42}
										alwaysShowMask={window.IS_MARS ? true : false}
										onChange={(e) => this.onEnterValue("account", e)}
										value={isWalletMaskVisible ? account : accountValue}
									/>
									<MaskedInputLabel
										isFocused={isWalletMaskVisible}
										hasValue={accountValue}>
										{translate("WALLET_ADDRESS")}
									</MaskedInputLabel>
								</MaskedInput>
							</Box>
						</FormItem>
					</Fragment>
				</BoxWrapper>
			</Content>
		);
	}

	goForward(step) {
		const { stake, selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		if (!this.state.canForward) return;

		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency === selectedCurrency
		);

		if (currency && stake < currency.withdraw.min) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MIN",
				title: "ERROR",
			});
			return;
		}

		if (currency && stake > currency.withdraw.max) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MAX",
				title: "ERROR",
			});
			return;
		}

		const newStep = step + 1;
		this.setState({ currentStep: newStep });
	}

	makeExternalPayment() {
		const { stake, accountValue, cryptocurrency, selectedCurrency } = this.state;
		let withdrawData = {
			type: "CryptoPay",
			username: getUser().username,
			amount: {
				value: Number(stake),
				currency: selectedCurrency ? selectedCurrency : "EUR",
			},
			receivedCurrency: cryptocurrency !== "" ? cryptocurrency : "BTC",
			walletAddress: accountValue,
			language: this.getActiveLanguageCode(),
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}

	render() {
		const { canForward } = this.state;
		return super.render();
	}
}
